import { t } from '@/ui/i18n/i18n';
import { computed, ref } from 'vue';
import { useTask } from '@/ui/concerns';
import { analyticsFilterList } from '@/services/api/resources/question';
import { FormItemFilterRecord } from '@/services/api/resources/analytics-builder/model';
import { v4 as uuidv4 } from 'uuid';
import { ApiError } from '@/services/api';
import { filter as getAllChecklists } from '@/services/api/resources/checklist';
import { filterListToOptions } from '@/ui/helpers';
import { SelectOptions } from '@/ui/types';

export const useReportTemplate = () => {
  const isLoadingFormItems = ref(false);
  const formItems = ref([] as FormItemFilterRecord[]);
  const formItemsRequestError = ref<ApiError | null>(null);

  const isLoadingFormTemplates = ref(false);
  const templates = ref([] as SelectOptions);

  const getFormItems = useTask(
    (formTemplateId: number | undefined) => analyticsFilterList({ templates: [formTemplateId!] }),
    ({ data }) => {
      formItems.value = data;
      isLoadingFormItems.value = false;
      formItemsRequestError.value = null;
    },
    uuidv4(),
    (error: ApiError) => {
      isLoadingFormItems.value = false;
      formItemsRequestError.value = error;
      console.error(error);
    },
  );

  const getFormTemplates = useTask(
    getAllChecklists,
    templateList => {
      templates.value = filterListToOptions(templateList, t('checklist.no-title2'));
      isLoadingFormTemplates.value = false;
    },
    uuidv4(),
    (error: ApiError) => {
      isLoadingFormTemplates.value = false;
      console.error(error);
    },
  );
  const getFormTemplatesTask = computed(() => getFormTemplates);

  return {
    isLoadingFormItems,
    formItems,
    getFormItems,
    formItemsRequestError,
    isLoadingFormTemplates,
    templates,
    getFormTemplatesTask,
  };
};
